<template>
  <tr class="sms-credit-list-item">
    <td>
      {{ creationDate}}
    </td>

    <td>
      {{ creditItem.amount }}
    </td>

    <td>
      {{ expirationDate }}
    </td>

    <td>
      {{ creditItem.usedAmount }}
    </td>

    <td>
      {{ typeText }}
    </td>

    <td>
      {{ cancelationDate }}
    </td>

    <td>
      <i v-if="!isCanceled"
         class="mdi mdi-close pointer"
         v-tooltip="`Deletar Créditos`"
         @click.stop="showDeleteModal"></i>
    </td>

    <confirmation-modal :value="showCreditDeleteModal"
                        confirm-label="Confirmar"
                        @confirm="deleteCredit"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        Deletar Créditos
      </span>
      <span>
        Quer mesmo deletar estes créditos? Esta ação é irreversível
      </span>
    </confirmation-modal>
  </tr>
</template>

<script>
import ConfirmationModal from "@components/ConfirmationModal";
import moment from "moment";

export default {
  components: {
    ConfirmationModal,
  },
  data() {
    return {
      isActive: false,
      showCreditDeleteModal: false,
    };
  },
  props: {
    creditItem: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    creationDate() {
      return moment(this.creditItem.creationDate).format("DD/MM/YYYY");
    },
    expirationDate() {
      return moment(this.creditItem.expirationDate).format("DD/MM/YYYY");
    },
    cancelationDate() {
      return this.isCanceled
        ? moment(this.creditItem.cancellationDate).format("DD/MM/YYYY")
        : "";
    },
    isCanceled() {
      return !!this.creditItem.cancellationDate;
    },
    typeText() {
      return { SMS: "SMS", EMAIL: "E-mail", WHATSAPP: "WhatsApp" }[this.creditItem.channelType];
    },
  },
  methods: {
    async deleteCredit() {
      await this.$api.marketing.account.credit.delete({
        accountId: this.creditItem.accountId,
        creditId: this.creditItem.id,
        type: this.creditItem.channelType,
      });

      this.$emit("deleted");

      this.closeDeleteModal();
    },
    closeDeleteModal() {
      this.showCreditDeleteModal = false;
    },
    showDeleteModal() {
      this.showCreditDeleteModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-credit-list-item {
  td {
    font-size: 15px;
  }
}
</style>
